var WS = require('../../scripts/ws');
var $ = require('jquery');
var Cookies = require('js-cookie');

$(function () {
    var bannerBuClass = 'ws-banner--bu',
        navBuClass = 'ws-nav--bu',
        megaMenuBuClass = 'ws-megamenu--bu',
        topBannerClass = 'ws-banner--position_top',
        bannerHiddenClass = 'ws-banner--hidden',
        topBannerSummarySelector = '.ws-accordion__summary--theme_notification-alert',
        cookieNotificationClass = 'ws-banner--theme_cookie-notification',
        overrideCookieFlag = 'override',

        $banners = $('.ws-banner'),
        $nav = $('.ws-nav'),

        isTopBannerExpanded,
        isBuNav = $nav.hasClass(navBuClass) || $nav.hasClass(megaMenuBuClass);

    function showBanner($banner) {
        if (isBuNav) {
            $banner.toggleClass(bannerBuClass, true);
        }

        if ($banner.data('toggleStyle') == 'slide') {
            $banner.stop().slideDown();
        }

        if ($banner.hasClass(cookieNotificationClass)) {
            $banner.toggleClass(bannerHiddenClass, false);
        }
    }

    function toggleBanner(e, $banner) {
        e.preventDefault();
        e.stopPropagation();

        if ($banner.hasClass(topBannerClass)) {
            if (isTopBannerExpanded) {
                isTopBannerExpanded = false;
                Cookies.set(getCookieName($banner), 1);
            } else {
                isTopBannerExpanded = true;
                Cookies.remove(getCookieName($banner));
            }
        }
        else {
            $banner.stop().slideUp(function () {
                if ($banner.hasClass(cookieNotificationClass)) {
                    if (getCookieExpiration($banner) === overrideCookieFlag) {
                        // Override cookie needs to be exist indefinitely until it's removed (after new expiration date is set)
                        Cookies.set(
                            getOverrideCookieName($banner),
                            1,
                            { expires: (10 * 365) }
                        );
                    }
                    else {
                        // Browser cookie exipration dates are inaccessible, so need to store the UTC DateTime string as cookie values.
                        // Standard cookie will expire on date set in Sitecore.
                        Cookies.set(
                            getCookieName($banner),
                            getCookieExpiration($banner),
                            { expires: new Date(getCookieExpiration($banner)) }
                        );
                    }
                }
                else {
                    Cookies.set(getCookieName($banner), 1);
                }
            });
        }
    }

    function getCookieName($banner) {
        return $banner.data('banner-cookie-name');
    }

    function getOverrideCookieName($banner) {
        return $banner.data('banner-cookie-override');
    }

    function getCookieExpiration($banner) {
        // Expiration dates are passed as UTC DateTime strings
        return $banner.data('banner-cookie-expiration');
    }

    function initializeBanner($banner) {
        var delay = parseInt($banner.data('delay'), 10) || 0;
        delay ? setTimeout(function () { showBanner($banner); }, delay) : showBanner($banner);
        $banner.find('.ws-banner__close-container').on('click', function (e) { toggleBanner(e, $banner); });
    }

    $banners.each(function (index, banner) {
        var $banner = $(banner);
        var cookieName = getCookieName($banner);
        var overrideCookieName = getOverrideCookieName($banner);
        var cookieExpiration = getCookieExpiration($banner);

        if (WS.isExperienceEditor()) {
            if (!$banner.hasClass(cookieNotificationClass)) {
                showBanner($banner);
            }
        }
        else if ($banner.hasClass(topBannerClass)) {
            var $bannerDetails = $banner.find('.ws-accordion__details--theme_notification-alert');
            isTopBannerExpanded = (($bannerDetails.length > 0) && $bannerDetails[0].hasAttribute('open'));

            $banner.find(topBannerSummarySelector).on('click keydown keyup', function (e) {
                const key = e.which || e.keyCode;

                if (e.type === "click" || key === 13 || key === 32) {
                    e.preventDefault();

                    if (e.type === "keydown") {
                        return;
                    }

                    toggleBanner(e, $banner);
                }
            });
        }
        else if (!$banner.hasClass(cookieNotificationClass) && !Cookies.get(cookieName)) { // Short-circuit Cookie Notification banner to handle logic separately
            initializeBanner($banner);
        }
        else if ($banner.hasClass(cookieNotificationClass)) {
            if (cookieExpiration === overrideCookieFlag) {
                // Need to forcibly show Cookie Notification
                if (!Cookies.get(overrideCookieName)) {
                    // User has NOT previously been forced to see new Cookie Notification
                    initializeBanner($banner);
                }
            }
            else {
                if (Cookies.get(overrideCookieName)) {
                    // User has previously seen a forced Cookie Notification, but we are no longer forcing it
                    Cookies.remove(overrideCookieName);

                    if (Cookies.get(cookieName)) {
                        // Replace user's old standard cookie with new expiration date
                        Cookies.remove(cookieName);
                        Cookies.set(cookieName, cookieExpiration, { expires: new Date(cookieExpiration) });
                    }
                    else {
                        // User happened to see forced Cookie Notification BEFORE standard one; need to create a standard cookie
                        Cookies.set(cookieName, cookieExpiration, { expires: new Date(cookieExpiration) });
                    }
                }
                else {
                    if (Cookies.get(cookieName)) {
                        // Need to check if user's cookie postdates the expiration set in Sitecore
                        var oldExpDate = new Date(Cookies.get(cookieName));
                        var newExpDate = new Date(cookieExpiration);

                        if (oldExpDate > newExpDate) {
                            // Update user's standard cookie, but do NOT show Cookie Notification
                            Cookies.remove(cookieName);
                            Cookies.set(cookieName, cookieExpiration, { expires: newExpDate });
                        }
                    }
                    else {
                        // From our perspective, show user Cookie Notification for the first time
                        initializeBanner($banner);
                    }
                }
            }
        }
    });
});